// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"746":"46acf145","810":"c3c7704c"}[chunkId] + ".css";
};